<div class="row">
  <div class="col-auto">
    <span
      [class.fw-700]="tituloBold"
      class="texto-4--color-segundario">{{ titulo }}</span>
  </div>
  <div class="col text-end">
    <span
      [class.texto-sucesso]="textoSucesso"
      class="desktop_body_P7 text-end">{{ conteudo ?? '-'}}</span>
  </div>
</div>
